import {
  GET_AUTH, GET_AUTH_SUCCESS, GET_AUTH_FAILURE,
  SET_AUTH_STATUS, SET_FORCE_AUTHENTICATION, SET_ACCOUNT_INDEX,
  SET_ACCOUNT_PERMS, HAS_SELECTED_ACCOUNT,
} from '../actions/auth';

const INITIAL_STATE = {
  loading: true,
};

// Add a reference to the index of each account as returned by CSP for account switching.
const accountWithIndex = (account, index) => ({ ...account, accountIndex: index });

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case GET_AUTH:
      return { ...state, loading: action.showLoading };
    case SET_ACCOUNT_PERMS:
      return {
        ...state,
        accountPerms: action.payload,
      };
    case GET_AUTH_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        macaroon: {
          ...action.payload,
          accounts: action.payload.accounts.map(accountWithIndex),
        },
      };
    case GET_AUTH_FAILURE:
      return { ...state, loading: false, error: true };
    case SET_AUTH_STATUS:
      return { ...state, status: action.payload };
    case SET_FORCE_AUTHENTICATION:
      return { ...state, redirect: true };
    case SET_ACCOUNT_INDEX:
      return {
        ...state,
        accountIndex: action.payload,
      };
    case HAS_SELECTED_ACCOUNT:
      return {
        ...state,
        hasSelectedAccount: !!action.payload,
      };
    default:
      return state;
  }
}
